import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "empty-state" }
const _hoisted_2 = { class: "empty-state__icon" }


export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyState',
  props: {
    title: {},
    description: {},
    icon: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("i", {
        class: _normalizeClass(["uil", __props.icon || 'uil-inbox']),
        "aria-hidden": "true"
      }, null, 2)
    ]),
    _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
    _createElementVNode("p", null, _toDisplayString(__props.description), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})